<template>
  <div class="success">
    <z-steps :active="2">
      <z-step
        class="step"
        v-for="(item, index) in horizontal"
        :key="index"
        :title="item.title"
        :image-active="item.imageActive"
        :image-deactive="item.imageDeactive"
      />
    </z-steps>
    <z-stance
      type="message"
      :show-info="false"
      :descText="info"
      img-src="https://pic4.zhuanstatic.com/zhuanzh/f9436be4-ddfb-4f7b-8047-f0ae914e714c.png"
    />
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Step, Steps, Stance } from '@zz-common/zz-ui'
// import { lego } from '@zz-common/lego'

import { queryParams } from '../../../lib/utils'

const query = queryParams()

export default {
  name: 'QualitySuccess',
  data() {
    return {
      status: query.status || this.$route.query.status || 'deal',
      horizontal: [
        {
          title: '营业执照',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        },
        {
          title: '经营许可',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '5f8eb272-7380-4e50-801b-1fdd5a19823d.png'
        },
        {
          title: '提交成功',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '5f8eb272-7380-4e50-801b-1fdd5a19823d.png'
        }
      ]
    }
  },
  computed: {
    info() {
      return this.status == 'deal' ? '提交成功，请耐心等待工作人员审核' : '恭喜您提交的资质审核通过，您可以发布许可经营范围内的商品啦'
    }
  },
  components: {
    zStep: Step,
    zSteps: Steps,
    zStance: Stance
  },
  methods: {
  },
  mounted() {
    native.setTitle({
      title: '资质提交'
    })
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
